@import 'ui-components/components/text/text.module.less';

@searchBarWidth: 400px;

.shared-width {
  width: @searchBarWidth;
}

.product-search-bar {
  .shared-width;
  position: relative;
}

.product-auto-complete {
  .paragraph;

  input {
    height: 32px;
  }
}

.auto-complete-dropdown {
  .shared-width;
  max-height: 300px;
  overflow: auto;
}
